var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGallerie(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b,.d{fill:none;}.b{stroke:#fff;}.c{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.155 -0.333)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.42 15.529)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1214.252,771.346a3.778,3.778,0,0,0-3.772-3.772h-2.017l-.86-4.287a3.777,3.777,0,0,0-4.441-2.954l-21.775,4.373a3.776,3.776,0,0,0-2.954,4.441l3.442,17.14a55.312,55.312,0,0,0,6.4,6.28h22.209a3.78,3.78,0,0,0,3.772-3.751h-.074l.074-.021ZM1183.1,786.235l-.357-1.719-3.132-15.6a2.58,2.58,0,0,1,2.017-3.034l21.778-4.373a2.579,2.579,0,0,1,3.031,2.02l.812,4.049h-18.973a3.777,3.777,0,0,0-3.772,3.772l0,10.254v6.253A2.576,2.576,0,0,1,1183.1,786.235Zm27.385,5.137h-22.209a2.6,2.6,0,0,1-2.564-2.356l1.017-1.11,5.4-5.884a2.262,2.262,0,0,1,3.406,0l3.189,3.477.946,1.032,2.448,2.668a.615.615,0,0,0,.845.039.6.6,0,0,0,.036-.848l-1.523-1.66.654-.693,1.422-1.508.889-.946a2.37,2.37,0,0,1,3.486,0l.048.051.9.958,4.176,4.429A2.584,2.584,0,0,1,1210.48,791.372Zm2.576-4.081-3.174-3.367-.824-.872-.271-.289a3.563,3.563,0,0,0-5.224,0l-2.049,2.174-.86.91-.571-.625-3.677-4.01a3.616,3.616,0,0,0-.327-.315,3.322,3.322,0,0,0-.461-.336,3.4,3.4,0,0,0-1.8-.509,3.488,3.488,0,0,0-2.585,1.16l-5.542,6.048V771.346a2.577,2.577,0,0,1,2.576-2.576h22.209a2.577,2.577,0,0,1,2.576,2.576Z",
    transform: "translate(-1178.359 -760.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1263.837,797.442a3.767,3.767,0,0,0-6.167,2.909.735.735,0,0,0,0,.08,3.594,3.594,0,0,0,.214,1.178,3.761,3.761,0,0,0,4.415,2.412,3.655,3.655,0,0,0,1.27-.565,3.764,3.764,0,0,0,.265-6.015ZM1262.5,802.7a2.588,2.588,0,0,1-1.062.229,2.505,2.505,0,0,1-.925-.172,2.592,2.592,0,0,1-1.645-2.273c0-.042,0-.086,0-.131a2.575,2.575,0,1,1,3.635,2.347Z",
    transform: "translate(-1234.078 -785.775)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-0.155 0.333)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 32,
    cy: 32,
    r: 32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 32,
    cy: 32,
    r: 31.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallerie);
export default __webpack_public_path__ + "static/media/gallerie.eb3fb97e37cecda0bcbde1a25fc53177.svg";
export { ForwardRef as ReactComponent };